// EditarAluguelForm.jsx
import React, { useEffect, useState } from 'react';
import {
  Box, Container, Typography, TextField, Button, Snackbar,
  Alert, Autocomplete, FormControlLabel, Switch,
  InputAdornment, MenuItem, LinearProgress
} from '@mui/material';
import { Save, Print } from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';
import { Navigate } from 'react-router-dom';


const API_URL = process.env.REACT_APP_API_URL;
const cartaoBandeiras = ['Visa', 'MasterCard', 'Elo', 'Diners', 'American Express', 'Outros'];
const formasPagamento = ['Cartão de Crédito', 'Pix', 'Transferência', 'Dinheiro'];
const tiposPeriodo = ['Diária', 'Semanal', 'Mensal'];
const statusAluguel = ['Reservado', 'Em Andamento', 'Finalizado', 'Cancelado', 'Pendencia'];

export default function EditarAluguelForm() {
  const { id } = useParams();
  const navigate = useNavigate();
const [devolucaoManual, setDevolucaoManual] = useState(false);

  const [clientes, setClientes] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [manutencoes, setManutencoes] = useState([]);
  const [promocoes, setPromocoes] = useState([]);
  const [form, setForm] = useState(null);
  const [resumo, setResumo] = useState({ dias: 0, diaria: 0, bruto: 0, desconto: '', total: 0, atraso: 0, multa: '' });
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({ open: false, msg: '', tipo: 'success' });
const [showDialog, setShowDialog] = useState(false);
const [deveRedirecionar, setDeveRedirecionar] = useState(false);

const [redirectAfterDialog, setRedirectAfterDialog] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    async function fetchData() {
      try {
        const [cRes, vRes, pRes, aRes, mRes] = await Promise.all([
          axios.get(`${API_URL}/clientes`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_URL}/veiculos`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_URL}/promocoes`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_URL}/alugueis/${id}`, { headers: { Authorization: `Bearer ${token}` } }),
          axios.get(`${API_URL}/manutencoes`, { headers: { Authorization: `Bearer ${token}` } })
        ]);
        setClientes(cRes.data);
        setVeiculos(vRes.data);
        setManutencoes(mRes.data || []);
        setPromocoes(pRes.data);

        const dados = aRes.data;
        const cliente = cRes.data.find(c => c.id === dados.id_cliente);
        const veiculo = vRes.data.find(v => v.id === dados.id_veiculo);
        const promocao = pRes.data.find(p => p.id === dados.promocao_id);

        setForm({
          cliente, veiculo, promocao,
          retirada: dados.data_retirada?.slice(0, 10) || '',
          devolucao: dados.data_devolucao?.slice(0, 10) || '',
          data_real_devolucao: dados.data_real_devolucao?.slice(0, 10) || '',
          tipo_periodo: dados.tipo_periodo || 'Diária',
          quantidade_periodos: dados.quantidade_periodos || 1,
          desconto_manual: dados.desconto_valor || 0,
          forma_pagamento: dados.forma_pagamento || '',
          bandeira_cartao: dados.bandeira_cartao || '',
          pago_na_retirada: !!dados.pago_na_retirada,
          observacoes_pagamento: dados.observacoes_pagamento || '',
          status_aluguel: dados.status_aluguel || 'Em Andamento'
        });
      } catch {
        setSnack({ open: true, msg: 'Erro ao carregar dados', tipo: 'error' });
      }
    }
    fetchData();
  }, [id]);

  useEffect(() => {
    if (form) atualizarResumo(form);
  }, [form]);



const atualizarResumo = (form) => {
  const diariaBase = form.veiculo?.preco_dia || 0;
  let diaria = diariaBase;
  let dias = Number(form.quantidade_periodos || 0);
  let tipo = form.tipo_periodo;

  if (tipo === 'Semanal' && form.veiculo?.preco_semana) {
    diaria = form.veiculo.preco_semana / 7;
    dias *= 7;
  } else if (tipo === 'Mensal' && form.veiculo?.preco_mes) {
    diaria = form.veiculo.preco_mes / 30;
    dias *= 30;
  }

  const retirada = form.retirada ? new Date(form.retirada) : null;
  const devolucao = retirada ? new Date(retirada.getTime() + dias * 86400000) : null;
  const bruto = diaria * dias;

  const descontoPromo = form.promocao
    ? Math.floor(dias / (form.promocao.dias_pagos + form.promocao.dias_ganhos)) * form.promocao.dias_ganhos * diaria
    : 0;

  const descontoManual = parseFloat(form.desconto_manual || 0);
  const descontoTotalCalculado = descontoPromo + descontoManual;

  let atraso = 0, multaCalculada = 0;
  if (form.data_real_devolucao && devolucao) {
    const real = new Date(form.data_real_devolucao);
    const delta = Math.ceil((real - devolucao) / 86400000);
    if (delta > 0) {
      atraso = delta;
      multaCalculada = atraso * diaria;
    }
  }

setResumo(prev => {
  const descontoFinal = parseFloat(prev.desconto !== '' ? prev.desconto : descontoTotalCalculado) || 0;
  const multaFinal = parseFloat(prev.multa !== '' ? prev.multa : multaCalculada) || 0;

  return {
    dias,
    diaria,
    bruto,
    desconto: prev.desconto !== '' ? prev.desconto : descontoTotalCalculado,
    multa: prev.multa !== '' ? prev.multa : multaCalculada,
    total: bruto - descontoFinal + multaFinal,
    atraso
  };
});


  // ✅ Controle da data devolução automática
  if (!devolucaoManual && retirada) {
    setForm(prev => ({
      ...prev,
      devolucao: devolucao?.toISOString().slice(0, 10)
    }));
  }
};



  const handleAuto = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));
const handleInput = (e) => {
  const { name, value, type, checked } = e.target;
  const val = type === 'checkbox' ? checked : value;

  setForm({ ...form, [name]: val });

  if (['desconto', 'multa'].includes(name)) {
    setResumo(prev => ({ ...prev, [name]: value }));
  } else {
    atualizarResumo({ ...form, [name]: val });
  }
};


const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  const token = localStorage.getItem('token');

  const dados = {
    id_cliente: form.cliente.id,
    id_veiculo: form.veiculo.id,
    promocao_id: form.promocao?.id || null,
    data_retirada: form.retirada,
    data_devolucao: form.devolucao,
    data_real_devolucao: form.data_real_devolucao?.trim() || null,
    valor_diaria: resumo.diaria,
    desconto_valor_manual: form.desconto_manual,
    forma_pagamento: form.forma_pagamento,
    bandeira_cartao: form.bandeira_cartao,
      status_pagamento: form.status_pagamento,

    pago_na_retirada: form.pago_na_retirada ? 1 : 0,
    observacoes_pagamento: form.observacoes_pagamento,
    status_aluguel: form.status_aluguel,
    tipo_periodo: form.tipo_periodo,
    quantidade_periodos: form.quantidade_periodos
  };

try {
  await axios.put(`${API_URL}/alugueis/${id}`, dados, {
    headers: { Authorization: `Bearer ${token}` }
  });

setSnack({ open: true, msg: 'Aluguel atualizado com sucesso.', tipo: 'success' });

setTimeout(() => {
  window.location.href = '/alugueis';
}, 1000);




} catch {
  setSnack({ open: true, msg: 'Erro ao salvar', tipo: 'error' });
} finally {
  setLoading(false);
}
};



  if (!form) return <LinearProgress />;

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box component="form" onSubmit={handleSubmit}
        sx={{ display: 'grid', gap: 3 }}>
        
        {/* HEADER */}
        <Box sx={{ bgcolor: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', color: '#333', p: 3, borderRadius: 2 }}>
          <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
            ✏️ Editar Aluguel #{id}
          </Typography>
          <Typography variant="body2" sx={{ color: '#333' }}>
            Atualize as informações do aluguel abaixo
          </Typography>
        </Box>

        {/* SEÇÃO 1: CLIENTE */}
        <Box sx={{ bgcolor: '#f8f9fa', p: 3, borderRadius: 2, border: '1px solid #e9ecef' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            👤 Dados do Cliente
          </Typography>
          <Autocomplete options={clientes} getOptionLabel={c => c.nome}
            value={form.cliente} onChange={(e, v) => handleAuto('cliente', v)}
            renderInput={p => <TextField {...p} label="Cliente *" />} />
        </Box>

        {/* SEÇÃO 2: PERÍODO DE ALUGUEL */}
        <Box sx={{ bgcolor: '#f8f9fa', p: 3, borderRadius: 2, border: '1px solid #e9ecef' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            📅 Período de Aluguel
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' }, gap: 2 }}>
            <TextField 
              name="retirada" 
              type="date" 
              label="Data Retirada *" 
              InputLabelProps={{ shrink: true }}
              value={form.retirada} 
              onChange={handleInput}
              required 
            />
            <TextField 
              select 
              name="tipo_periodo" 
              label="Tipo de Período"
              value={form.tipo_periodo} 
              onChange={handleInput}
            >
              {tiposPeriodo.map(tp => <MenuItem key={tp} value={tp}>{tp}</MenuItem>)}
            </TextField>
            <TextField 
              name="quantidade_periodos" 
              label="Quantidade"
              type="number" 
              value={form.quantidade_periodos} 
              onChange={handleInput} 
            />
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mt: 2 }}>
            <TextField 
              name="devolucao" 
              label="Data Prevista Devolução"
              value={form.devolucao} 
              disabled
              slotProps={{ input: { sx: { bgcolor: '#e9ecef' } } }}
            />
            <TextField 
              name="data_real_devolucao" 
              type="date" 
              label="Data Real Devolução"
              InputLabelProps={{ shrink: true }} 
              value={form.data_real_devolucao} 
              onChange={handleInput} 
            />
          </Box>
        </Box>

        {/* SEÇÃO 3: SELEÇÃO DE VEÍCULO */}
        <Box sx={{ bgcolor: '#f8f9fa', p: 3, borderRadius: 2, border: '1px solid #e9ecef' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            🚗 Veículo
          </Typography>
          <Autocomplete
            options={veiculos.filter(v => {
              const emManutencao = manutencoes.some(m =>
                m.veiculo_id === v.id && ['Em Andamento', 'Agendada'].includes(m.status)
              );
              return !emManutencao || v.id === form.veiculo?.id;
            })}
            getOptionLabel={v => `${v.modelo} - ${v.placa}`}
            value={form.veiculo}
            onChange={(e, v) => handleAuto('veiculo', v)}
            renderInput={p => <TextField {...p} label="Veículo *" required />}
          />
        </Box>

        {/* SEÇÃO 4: PROMOÇÃO (opcional) */}
        <Box sx={{ bgcolor: '#f8f9fa', p: 3, borderRadius: 2, border: '1px solid #e9ecef' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            🎁 Promoção (Opcional)
          </Typography>
          <Autocomplete options={promocoes} getOptionLabel={p => p.nome}
            value={form.promocao} onChange={(e, v) => handleAuto('promocao', v)}
            renderInput={p => <TextField {...p} label="Promoção" />} />
        </Box>

        {/* SEÇÃO 5: RESUMO FINANCEIRO */}
        <Box sx={{ bgcolor: '#e7f3ff', p: 3, borderRadius: 2, border: '2px solid #667eea' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            💰 Resumo Financeiro
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: '1fr 1fr 1fr 1fr' }, gap: 2 }}>
            <TextField 
              label="Dias" 
              value={resumo.dias} 
              disabled
              slotProps={{ input: { sx: { bgcolor: 'white' } } }}
            />
            <TextField 
              label="Diária (R$)" 
              value={Number(resumo.diaria || 0).toFixed(2)} 
              disabled
              slotProps={{ input: { sx: { bgcolor: 'white' } } }}
            />
            <TextField 
              label="Valor Bruto (R$)" 
              value={Number(resumo.bruto || 0).toFixed(2)} 
              disabled
              slotProps={{ input: { sx: { bgcolor: 'white' } } }}
            />
            <TextField
              label="Desconto (R$)"
              name="desconto"
              value={resumo.desconto}
              onChange={handleInput}
              InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
            />
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: '1fr 1fr 1fr 1fr' }, gap: 2, mt: 2 }}>
            <TextField 
              label="Dias em Atraso" 
              value={resumo.atraso} 
              disabled
              slotProps={{ input: { sx: { bgcolor: 'white' } } }}
            />
            <TextField
              label="Multa (R$)"
              name="multa"
              value={resumo.multa}
              onChange={handleInput}
              InputProps={{ startAdornment: <InputAdornment position="start">R$</InputAdornment> }}
            />
          </Box>
          <Box sx={{ mt: 2, p: 2, bgcolor: 'white', borderRadius: 1, border: '2px solid #667eea' }}>
            <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#667eea' }}>
              Total a Pagar: R$ {resumo.total.toFixed(2)}
            </Typography>
          </Box>
        </Box>

        {/* SEÇÃO 6: PAGAMENTO */}
        <Box sx={{ bgcolor: '#f8f9fa', p: 3, borderRadius: 2, border: '1px solid #e9ecef' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, color: '#333' }}>
            💳 Forma de Pagamento
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2 }}>
            <TextField 
              select 
              label="Forma de Pagamento *" 
              name="forma_pagamento"
              value={form.forma_pagamento} 
              onChange={handleInput}
              required
            >
              {formasPagamento.map(f => <MenuItem key={f} value={f}>{f}</MenuItem>)}
            </TextField>

            {form.forma_pagamento === 'Cartão de Crédito' && (
              <TextField 
                select 
                label="Bandeira *" 
                name="bandeira_cartao"
                value={form.bandeira_cartao} 
                onChange={handleInput}
                required
              >
                {cartaoBandeiras.map(b => <MenuItem key={b} value={b}>{b}</MenuItem>)}
              </TextField>
            )}
          </Box>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' }, gap: 2, mt: 2 }}>
            <TextField 
              select 
              label="Status de Pagamento"
              name="status_pagamento"
              value={form.status_pagamento}
              onChange={handleInput}
            >
              <MenuItem value="Pendente">Pendente</MenuItem>
              <MenuItem value="Pago">Pago</MenuItem>
              <MenuItem value="Parcial">Parcial</MenuItem>
              <MenuItem value="Cancelado">Cancelado</MenuItem>
            </TextField>
            <TextField 
              select 
              label="Status do Aluguel"
              name="status_aluguel"
              value={form.status_aluguel} 
              onChange={handleInput}
            >
              {statusAluguel.map(st => <MenuItem key={st} value={st}>{st}</MenuItem>)}
            </TextField>
          </Box>
          <FormControlLabel 
            control={
              <Switch 
                name="pago_na_retirada" 
                checked={form.pago_na_retirada} 
                onChange={handleInput} 
              />
            } 
            label="Pago na Retirada" 
            sx={{ mt: 2 }}
          />
          <TextField 
            label="Observações" 
            name="observacoes_pagamento"
            value={form.observacoes_pagamento} 
            onChange={handleInput}
            multiline 
            rows={2}
            fullWidth
            sx={{ mt: 2 }}
          />
        </Box>

        {/* LOADING */}
        {loading && <LinearProgress sx={{ borderRadius: 1 }} />}

        {/* BOTÕES */}
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', pt: 2 }}>
          <Button
            variant="text"
            onClick={() => window.location.href = '/alugueis'}
            color="inherit"
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            startIcon={<Print />}
            onClick={() => window.print()}
            sx={{ background: 'linear-gradient(135deg, #26a69a 0%, #00897b 100%)', color: 'white' }}
          >
            Imprimir
          </Button>
          <Button
            variant="contained"
            startIcon={<Save />}
            type="submit"
            disabled={loading}
            color="primary"
            sx={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
          >
            Atualizar Aluguel
          </Button>
        </Box>
      </Box>

      <Dialog open={showDialog} maxWidth="xs" fullWidth>
        <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>✔️ Sucesso!</DialogTitle>
        <DialogContent>
          <Typography align="center">Aluguel atualizado com sucesso.</Typography>
        </DialogContent>
      </Dialog>

      <Snackbar open={snack.open} autoHideDuration={3000} onClose={() => setSnack(s => ({ ...s, open: false }))}>
        <Alert severity={snack.tipo}>{snack.msg}</Alert>
      </Snackbar>
    </Container>
  );
}
